import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'
import { environment } from 'src/environments/environment'

@Injectable()
export class SurefirePageTitleStrategy extends TitleStrategy {
    constructor(private readonly title: Title) {
        super()
    }

    override updateTitle(routerState: RouterStateSnapshot) {
        const title = this.buildTitle(routerState)

        if (title !== undefined) {
            this.title.setTitle(`${title} - Surefire Software`)
        }

        if (!environment.production) {
            this.title.setTitle(`${this.title.getTitle()} (dev)`)
        }
    }
}
